<dx-toolbar class="toolbar-container">
    <dxi-item location="before">
        <div *dxTemplate>
            <span>Enter Payment Details:&nbsp;</span>
            <dx-switch
                switchedOnText="Yes"
                switchedOffText="No"
                [disabled]="invoiceOption === 'generate_payment_request' || !communityId"
                [elementAttr]="{ class: 'field-switch-small' }"
                [(value)]="showAdvanceMode"
                (onValueChanged)="onAdvanceModeValueChange()"
            ></dx-switch>
        </div>
    </dxi-item>
    <dxi-item location="after" [visible]="!!selectedVendor && showAdvanceMode && isInternalUser">
        <div *dxTemplate class="toolbar-content">
            <div class="icon-container half-width">
                <div class="icon-label-content half-width" (click)="onVendorNotesClick()">
                    <ng-container *ngIf="!selectedVendor?.hasNotes">
                        <i
                            title="Vendor Notes"
                            class="fa-2x dx-theme-accent-as-text-color"
                            [ngClass]="iconEmptyNotes"
                        ></i>
                    </ng-container>
                    <ng-container *ngIf="selectedVendor?.hasNotes">
                        <i title="Vendor Notes" class="fa-2x cc-icon-check" [ngClass]="iconNotes"></i>
                    </ng-container>
                </div>
                <div class="icon-label-content half-width" (click)="onVendorNotesClick()">Vendor Notes</div>
            </div>
        </div>
    </dxi-item>
    <dxi-item location="after" [visible]="!!selectedVendor && showAdvanceMode">
        <div *dxTemplate class="toolbar-content">
            <div class="icon-container half-width">
                <div class="icon-label-content half-width" (click)="onVendorActivitiesClick()">
                    <i
                        title="Vendor Activities"
                        class="fa-2x dx-theme-accent-as-text-color"
                        [ngClass]="iconHistory"
                    ></i>
                </div>
                <div class="icon-label-content half-width" (click)="onVendorActivitiesClick()">Vendor Activities</div>
            </div>
        </div>
    </dxi-item>
    <dxi-item location="after" [visible]="!!selectedVendor && showAdvanceMode">
        <div *dxTemplate class="toolbar-content">
            <div class="icon-container half-width">
                <div class="icon-label-content half-width" (click)="onBoardApprovalClick()">
                    <i title="Board Approval" class="fa-2x cc-icon-check" [ngClass]="iconCheck"></i>
                </div>
                <div class="icon-label-content half-width" (click)="onBoardApprovalClick()">Board Approval</div>
            </div>
        </div>
    </dxi-item>
    <dxi-item location="after" [visible]="!!selectedVendor && showAdvanceMode">
        <div *dxTemplate class="toolbar-content">
            <div class="icon-container half-width">
                <div class="icon-label-content half-width">
                    <i
                        title="Work Orders"
                        class="fa-2x dx-theme-accent-as-text-color"
                        [ngClass]="iconHardHat"
                        (click)="onWorkOrderClick()"
                    ></i>
                </div>
                <div class="icon-label-content half-width" (click)="onWorkOrderClick()">Work Orders</div>
            </div>
        </div>
    </dxi-item>
</dx-toolbar>

<app-workflow-vendor-notes
    *ngIf="showVendorNotesPopUp"
    [communityId]="communityId"
    [vendorCode]="selectedVendor?.vendorCode"
    [vendorName]="selectedVendor?.vendorName"
    (onVendorNotesClose)="onVendorNotesClose($event)"
></app-workflow-vendor-notes>

<app-workflow-iva-history
    *ngIf="showVendorHistory"
    [communityId]="communityId"
    [payee]="selectedVendor?.vendorName"
    [mode]="'vendorHistory'"
    [title]="'Vendor History'"
    [vendorHistoryBaseParams]="vendorHistoryBaseParams"
    (closeIVAHistory)="onVendorHistoryClose()"
></app-workflow-iva-history>

<app-workflow-board-approval-viewer
    *ngIf="showBoardApproval"
    [communityId]="communityId"
    (onClose)="onBoardApprovalClose()"
></app-workflow-board-approval-viewer>

<app-workflow-payment-work-order-selector
    *ngIf="showWorkOrder"
    [communityId]="communityId"
    [vendorId]="selectedVendor?.vendorId"
    [workOrderIds]="workOrderIds"
    (onClose)="onWorkOrderSelectorClose()"
    (onWorkOrderSelection)="onWorkOrderIdSelection($event)"
></app-workflow-payment-work-order-selector>
